import type { TModule } from '@modules/core/types';

import { HELP_CENTER_ROUTE_PATHS } from './config';
import { ACTION_CONFIG_ROUTES } from './action-configs';
import { CONTENT_ROUTES } from './content';
import { KNOWN_ISSUES_ROUTES } from './known-issues';
import { QUICK_ACTIONS_ROUTES } from './quick-actions';
import { WORKFLOWS_ROUTES } from './workflows';

const helpCenterModule: TModule = {
  id: 'help-center',
  fallbackRoute: [HELP_CENTER_ROUTE_PATHS.actionConfigs],
  permissions: { roles: [] },
  isPublic: false,
  routes: [
    ...ACTION_CONFIG_ROUTES,
    ...WORKFLOWS_ROUTES,
    ...CONTENT_ROUTES,
    ...QUICK_ACTIONS_ROUTES,
    ...KNOWN_ISSUES_ROUTES,
  ],
};

export { HELP_CENTER_ROUTE_PATHS as HelpCenterRoutePaths };

export default helpCenterModule;
